<template>
  <div>
    <l-map
      :zoom="zoom"
      :center="center"
      style="height: 1000px; width: 100%;"
      :options="{zoomControl: false,
      attributionControl:false,
      dragging: true,
      scrollWheelZoom:false,
      zoomSnap:0.1,
      doubleClickZoom:false,
      touchZoom:false}"
    >
      <l-marker v-for="marker in markers" v-bind:key="marker.uid" :lat-lng="marker.position" :icon="icon"></l-marker>
      <l-geo-json
        v-if="show"
        :geojson="geojson"
        :options-style="styleFunction"
      />
    </l-map>
  </div>
</template>

<script>
// import { latLng } from "leaflet";
import { LMap, LGeoJson, LMarker } from "vue2-leaflet";
import { icon } from "leaflet";

export default {
  inject: ["eventHub"],
  name: "Example",
  components: {
    LMap,
    LGeoJson,
    LMarker
  },
  data() {
    return {
      loading: false,
      show: true,
      enableTooltip: false,
      zoom: 8,
      center: [23.6, 121],
      geojson: null,
      opacity:0,
      markers:{},
      fillColor: "#fff",
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      icon: icon({
        iconUrl: require("../assets/pi-icon-2x.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 16]
      }),
    };
  },
  computed: {
    styleFunction() {
      const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 1.5,
          color: "#121212",
          opacity: 1,
          fillColor: fillColor,
          fillOpacity: 1
        };
      };
    },
    onEachFeatureFunction() {
      if (!this.enableTooltip) {
        return () => {};
      }
      return (feature, layer) => {
        layer.bindTooltip(
          "<div>code:" +
            feature.properties.code +
            "</div><div>nom: " +
            feature.properties.nom +
            "</div>",
          { permanent: false, sticky: true }
        );
      };
    }
  },
  async created() {
    this.eventHub.$on('firestore', (msg)=> {
      this.markers = msg.markers;
    })
    
    this.loading = true;
    const response = await fetch("/geojson/taiwan.geo.json");
    const data = await response.json();
    this.geojson = data;
    this.loading = false;

    
  }
};
</script>
<style scoped>
.leaflet-container {
    background-color:rgba(255,0,0,0.0);
}
</style>
